/**
 * haptics.js
 * Tiny guarded wrappers around navigator.vibrate for touch feedback ("juice").
 * No-ops silently on platforms without the API (iOS Safari, desktop) — callers
 * never need to feature-detect.
 */

function vibrate(pattern) {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(pattern)
    }
  } catch {
    // vibration is best-effort feedback — never let it throw into UI code
  }
}

/** Light tick — qty change, swipe commit. */
export function hapticTap() {
  vibrate(10)
}

/** Firmer single knock — reaching a hard edge, destructive confirm. */
export function hapticImpact() {
  vibrate(22)
}

/** Short success pattern — celebration moments (discount tier / promo step). */
export function hapticSuccess() {
  vibrate([24, 40, 32])
}
